import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject, input, linkedSignal, OnInit } from '@angular/core';
import { SharedUI } from '@sharedUI/exports';

@Component({
  selector: 'app-ai-load-animation',
  imports: [ SharedUI ],
  template: '<so-ai-loader-ui [size]="$scale()" />',
})
export class AILoadAnimation implements OnInit {
  // Dependencias
  private readonly dialogData = inject<{ scale: number }>(DIALOG_DATA, { optional: true });

  // Inputs
  $_scale = input<number>(48, { alias: 'scale' });
  $scale = linkedSignal(this.$_scale);

  ngOnInit(): void {
    if (this.dialogData)
      this.$scale.set(this.dialogData.scale);
  }
}
